/**
 * Detects transport-layer failures (DNS, TCP, TLS, timeouts) where no HTTP response exists.
 * Used to queue patrol scans and attempt offline session unlock on login.
 */
const TRANSPORT_SUBSTRINGS = [
  "unable to resolve host",
  "no address associated with hostname",
  "network is unreachable",
  "failed to connect",
  "connection refused",
  "connection reset",
  "connection timed out",
  "timed out",
  "timeout",
  "ssl",
  "certificate",
  "econnrefused",
  "econnreset",
  "etimedout",
  "enotfound",
  "network request failed",
  "failed to fetch",
  "load failed",
  "the internet connection appears to be offline",
  "err_internet_disconnected",
] as const;

function messageFromUnknown(error: unknown): string {
  if (error instanceof Error) return error.message;
  if (typeof error === "string") return error;
  try {
    return JSON.stringify(error);
  } catch {
    return String(error);
  }
}

export function isTransportError(error: unknown): boolean {
  const msg = messageFromUnknown(error).toLowerCase();
  if (!msg.trim()) return false;
  for (const s of TRANSPORT_SUBSTRINGS) {
    if (msg.includes(s)) return true;
  }
  if (error instanceof TypeError && msg.includes("fetch")) return true;
  return false;
}
